// extracted by mini-css-extract-plugin
module.exports = {"notification":"NotificationIndicator_notification__3H596"};